import React, { useState, useEffect, useCallback } from "react";
import {
  Avatar,
  Form,
  Input,
  Select,
  Button,
  Row,TimePicker,
  Col,InputNumber,
  notification,
  message
} from "antd";
import { useDropzone } from "react-dropzone";
import dayjs from 'dayjs';

import NoAvatar from "../../../../assets/img/png/no-avatar.png";
import {
  updateHubApi,
  uploadAvatarApi,
  getAvatarApi,
} from "../../../../api/user";
import { getAccessTokenApi } from "../../../../api/auth";
import { put } from "../../../../api/put";
import "./EditHubsForm.scss";

export default function EditHubsForm(props) {
  const { hub, setIsVisibleModal, setReloadHubs } = props;
  const [avatar, setAvatar] = useState(null);
  const [hubData, setHubData] = useState({});

  useEffect(() => {
    console.log('innnnnnnn ',hub.earlyTime,' -- ',hubData.earlyTime,' -------- ',dayjs(hubData.earlyTime, 'HH:mm'))
    // const [horasE, minutosE] = hub.earlyTime.split(':'); 
    // const horaDayjs = dayjs().set('hour', horasE).set('minute', minutosE);
    hub.postalCode= parseInt(hub.postalCode)
    hub.latitud= parseFloat(hub.latitud)
    hub.longitud= parseFloat(hub.longitud)
    hub.fixcost= parseFloat(hub.fixcost)
    hub.monthlypayment= parseFloat(hub.monthlypayment)
    setHubData({
      name: hub.name,
      postalCode: hub.postalCode,
      latitud: hub.latitud,
      longitud: hub.longitud,
      earlyTime: hub.earlyTime,
      lateTime: hub.lateTime,
      monthlypayment: hub.monthlypayment,
    });
  }, [hub,setHubData]);

  useEffect(() => {
    if (hub.avatar) {
      // getAvatarApi(worker.avatar).then((response) => {
      //   setAvatar(response);
      // });
      setAvatar(hub.avatar)
    } else {
      setAvatar(null);
    }
  }, [hub]);

  useEffect(() => {
    if (avatar) {
      setHubData({ ...hubData, avatar: avatar.file });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [avatar]);

  const updateHub = (e) => {
   //console.log('he entrado al updateHub')
    e.preventDefault();
    const token = getAccessTokenApi();
    let hubUpdate = hubData;

    if (!hubUpdate.name || 
      !hubUpdate.postalCode ||
      !hubUpdate.latitud ||
      !hubUpdate.longitud ||
      !hubUpdate.earlyTime ||
      !hubUpdate.lateTime ||
       !hubUpdate.monthlypayment) {
      // notification["error"]({
      //   message: "Todos los campos son obligatorios.",
      // });
      message.error("Todos los campos son obligatorios.")
      return;
    }
    if (typeof hubUpdate.avatar === "object") {
      uploadAvatarApi(token, hubUpdate.avatar, hub.name,'upload-avatar-hub').then((response) => {
        hubUpdate.avatar = response.avatarName;
        put(hubUpdate,'update-hub','update-hub',`/${hub.name}` ).then((result) => {
        // updateHubApi(token, hubUpdate, hub.name).then((result) => {
          // notification["success"]({
          //   message: 'Changes saved!',
          // });
          message.success('Changes saved!')
          setIsVisibleModal(false);
          setReloadHubs(true);
        });
      });
    } else {
      put(hubUpdate,'update-hub','update-hub',`/${hub.name}` ).then((result) => {
      // updateHubApi(token, hubUpdate, hub.name).then((result) => {
        // notification["success"]({
        //   message: 'Changes saved!',
        // });
        message.success('Changes saved!')
        setIsVisibleModal(false);
        setReloadHubs(true);
      });
    }
  };

  return (
    <div className="edit-hub-form">
      <UploadAvatar avatar={avatar} setAvatar={setAvatar} />
      <EditForm
        hubData={hubData}
        hub={hub}
        setHubData={setHubData}
        updateHub={updateHub}
      />
    </div>
  );
}

function UploadAvatar(props) {
  const { avatar, setAvatar } = props;
  const [avatarUrl, setAvatarUrl] = useState(null);

  useEffect(() => {
    if (avatar) {
      if (avatar.preview) {
        setAvatarUrl(avatar.preview);
      } else {
        setAvatarUrl(avatar);
      }
    } else {
      setAvatarUrl(null);
    }
  }, [avatar]);

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      setAvatar({ file, preview: URL.createObjectURL(file) });
    },
    [setAvatar]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: "image/jpeg, image/png",
    noKeyboard: true,
    onDrop,
  });

  return (
    <div className="upload-avatar" {...getRootProps()}>
      <input {...getInputProps()} />
      {isDragActive ? (
        <Avatar size={150} src={NoAvatar} />
      ) : (
        <Avatar size={150} src={avatarUrl ? avatarUrl : NoAvatar} />
      )}
    </div>
  );
}

function EditForm(props) {
  const { hubData, setHubData, updateHub,hub } = props;
  const { Option } = Select;

  return (
    <Form className="form-edit" onSubmit={updateHub}>
       <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <Input
              //prefix={<Icon type="user" />}
              placeholder="Name"
              value={hubData.name}
              onChange={(e) =>
                {
                  // console.log(hubData)
                setHubData({ ...hubData, name: e.target.value })}
              }
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Postal Code'
              name='Postal Code'
              min={0}
              max={9999999}
              step={1}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              // defaultValue={hub.postalCode} 
              value={hubData.postalCode}
              onChange={(e) => 
                {setHubData({ ...hubData, postalCode: e })}}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Latitude'
              name='latitude'
              min={-180}
              max={180}
              step={0.0000001}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              // defaultValue={hub.latitud} 
              value={hubData.latitud}
              onChange={(e) => 
                
                {setHubData({ ...hubData, latitud: e.toFixed(7) })}}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Longitude'
              name='longitude'
              min={-180}
              max={180}
              step={0.0000001}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              // defaultValue={hub.latitud} 
              value={hubData.longitud}
              onChange={(e) => 
                {setHubData({ ...hubData, longitud: e.toFixed(7) })}}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <TimePicker 
            name='Early Time'
            placeholder="Early Time"
            // defaultValue={dayjs().set('hour', hub.earlyTime.split(':')[0]).set('minute', hub.earlyTime.split(':')[1])}
            value={dayjs().set('hour', (hubData.earlyTime===undefined)?hub.earlyTime.split(':')[0]:hubData.earlyTime.split(':')[0]).set('minute', (hubData.earlyTime===undefined)?hub.earlyTime.split(':')[1]:hubData.earlyTime.split(':')[1])}
            format={'HH:mm'} 
            onChange={(time)=>{
              setHubData({ ...hubData, earlyTime: time.format('HH:mm') })
              }}/>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item>
              <TimePicker 
              name='Late Time'
              placeholder="Late Time"
              value={dayjs().set('hour', (hubData.lateTime===undefined)?hub.lateTime.split(':')[0]:hubData.lateTime.split(':')[0]).set('minute', (hubData.lateTime===undefined)?hub.lateTime.split(':')[1]:hubData.lateTime.split(':')[1])}
              // defaultValue={dayjs().set('hour', hub.lateTime.split(':')[0]).set('minute', hub.lateTime.split(':')[1])}
              format={'HH:mm'} 
              onChange={(time)=>{
                // console.log(time)
                setHubData({ ...hubData, lateTime: time.format('HH:mm') })
                }}/>
            </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Monthly payment'
              name='monthly payment'
              min={0}
              max={9999999}
              step={0.01}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              // defaultValue={hub.monthlypayment} 
              value={hubData.monthlypayment}
              onChange={(e) => 
                {setHubData({ ...hubData, monthlypayment: e })}}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="btn-submit" onClick={updateHub}>
              Update hub
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}
